// 通用模块
<template>
  <div class="DkbGM">
    <div class="GMContent DkbScroll">
      <!-- 设备 -->
      <div class="deviceArea" v-if="!(DeviceArea.OnlineNum ===0  &&  DeviceArea.OfflineNum === 0)">
        <!-- 设备环形图 -->
        <div class="chart">
          <div id="onlineRateGM" ref="onlineRateGM"></div>
          <!-- <p class="text">设备在线率</p>
          <p class="num">{{DeviceArea.OnlineRate}}</p> -->
        </div>
        <div class="right" v-if="DeviceArea.OfflineList">
          <div class="listBox">
            <p class="tit">离线设备</p>
            <ul class="list DkbScroll" v-if="DeviceArea.OfflineList.length !== 0">
              <li class="li"
                :class="['one-line-overhidden', {'selected': OfflineSelected===index}]"
                v-for="(item, index) in DeviceArea.OfflineList" :key="index"
                @click="OfflineSelected = index">{{item.DeviceName}}</li>
            </ul>
          </div>
          <div class="detailBox">
            <p class="tit">详情</p>
            <div class="detail" v-if="DeviceArea.OfflineList.length !== 0">
              <p class="label">设备名称：</p>
              <p class="text">{{DeviceArea.OfflineList[OfflineSelected].DeviceName}}</p>
              <p class="label">设备编号：</p>
              <p class="text">{{DeviceArea.OfflineList[OfflineSelected].DeviceId}}</p>
              <p class="label">所属空间位置：</p>
              <p class="text">{{DeviceArea.OfflineList[OfflineSelected].SpaceName}}</p>
            </div>
          </div>
          <p class="noDevice" v-if="DeviceArea.OfflineList.length === 0">暂无离线设备</p>
        </div>
      </div>
      <NoData v-else></NoData>
      <!-- 实时操作 -->
      <template v-if="!$route.meta.LSS">
      <div class="realOperateArea" v-if="RealOperateArea !== undefined  &&  RealOperateArea.length > 0">
        <p class="Tit">实时操作显示</p>
        <div class="li tit">
          <p class="time">操作时间</p>
          <p class="con">操作内容</p>
        </div>
        <div class="list DkbScroll">
          <div class="li" v-for="(item, index) in RealOperateArea" :key="index">
            <p class="time">{{item.Time}}</p>
            <p class="con">{{item.Content}}</p>
          </div>
        </div>
      </div>
      <NoData v-else></NoData>
      </template>
      <!-- 库存记录 -->
      <div class="KCSLArea" v-if="KCSLArea !== undefined  &&  KCSLArea.length > 0">
        <p class="Tit">库存记录</p>
        <div class="li tit">
          <p class="warehouse">仓库</p>
          <p class="name">产品名称</p>
          <p class="number">产品编号</p>
          <p class="status">是否在库</p>
        </div>
        <div class="list DkbScroll">
          <div class="li" v-for="(item, index) in KCSLArea" :key="index">
            <p class="warehouse">{{item.Warehouse}}</p>
            <p class="name">{{item.Name}}</p>
            <p class="number">{{item.Number}}</p>
            <p class="status">{{item.Status === 1 ? '在库' : '不在库'}}</p>
          </div>
        </div>
      </div>
      <NoData v-else></NoData>
      <!-- 预警信息 -->
      <!-- <div :class="['warningArea', {'has': WarningText !== ''}]">
        <p class="tit">预警信息</p>
        <p class="text">{{WarningText === '' ? '暂无预警' : WarningText}}</p>
      </div> -->
      <!-- 预警信息 -->
      <div :class="['warningArea', {'has': WarningInfo.length !== 0 }]">
        <p class="tit">预警信息</p>
        <div class="list DkbScroll">
          <div class="li" v-for="(item, index) in WarningInfo" :key="index">
            <div class="top">
              <p class="time">{{item.Date}}</p>
              <p class="type">{{item.Type}}</p>
            </div>
            <p class="des">{{item.Content}}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import NoData from '@/components/DkbPage/GM/NoData'
  import { dkbApi } from "../../../../static/js/dkb/dkb.js"
  import { showToast } from "../../../../static/js/utility/utility.js"
  let echarts = require('echarts')
  let vm, timer1, timer2

  export default {
    name: 'DkbGM',
    components: {
      NoData
    },
    computed: {},
    data () {
      return {
        // 设备
        DeviceArea: {},
        OfflineSelected: 0,
        // 实时操作显示
        RealOperateArea: {},
        // 库存记录
        KCSLArea: {},
        // 预警信息
        WarningText: '',
        WarningInfo: []
      }
    },
    created () {
      vm = this
    },
    mounted () {
      vm.getGMInfo()
      vm.timeRefresh()
    },
    destroyed () {
      clearInterval(timer1)
      clearInterval(timer2)
    },
    methods: {
      // 定时刷新数据
      timeRefresh () {
        timer1 = setInterval(()=>{
          vm.getGMWarningInfo()
          vm.getGMRealOperateInfo()
          vm.getGMKCSLInfo()
        }, 1000*5)
        timer2 = setInterval(()=>{
          vm.getGMDeviceInfo()
        }, 1000*30)
      },
      // 获取固定（通用）版块的信息
      async getGMInfo () {
        let res = await dkbApi.getGMInfo()
        // console.log('res', res)
        if (res.ErrCode === 0)  {
          let GMInfo = res.Result
          for (let i in GMInfo) {
            vm[i] = GMInfo[i]
          }
          // console.log('WarningInfo', vm.WarningInfo)

          // 绘制在线率图表
          if(!(vm.DeviceArea.OnlineNum ===0  &&  vm.DeviceArea.OfflineNum === 0)) {
            vm.$nextTick(()=>{
              vm.getDeviceDC()
            })
          }
        } else {
          showToast(res.ErrMsg)
        }
      },
      // 加载获取设备环形图
      getDeviceDC () {
        // console.log('重新绘制图表', '')
        // 获取参数值
        let {OnlineNum, OfflineNum, OnlineRate} = vm.DeviceArea
        let myChart = echarts.init(document.getElementById('onlineRateGM'))
        let htmlFontSize = vm.$store.state.htmlFontSize,
            shadowBlur = (4/100)*htmlFontSize,
            labelFPadding = (80/100)*htmlFontSize,
            aFontSize = (30/100)*htmlFontSize,
            aPadding = (4/100)*htmlFontSize,
            bFontSize = (15/100)*htmlFontSize,
            bPadding = (6/100)*htmlFontSize
        let option = {
          grid: {
            // width: (200/100)*htmlFontSize,
            // height: (300/100)*htmlFontSize,
            width: (200/100)*htmlFontSize,
            height: (300/100)*htmlFontSize,
            // left: 0,
            // right: 0,
            // top: 0,
            // bottom: 0,
            containLabel: true
          },
          title: {
              text: '设备在线率',
              subtext: OnlineRate+'%',
              left: 'center',
              top: (95/100)*htmlFontSize,
              textStyle: {
                  color: '#fff',
                  fontSize: (15/100)*htmlFontSize,
              },
              subtextStyle: {
                  color: '#fff',
                  fontSize: (40/100)*htmlFontSize,
                  fontWeight: 'lighter',
              },
              itemGap: (15/100)*htmlFontSize //主副标题间距
          },
          series: [
            {
              name:'',
              type:'pie',
              radius: [(55/100)*htmlFontSize, (73/100)*htmlFontSize],
              clockwise: false,  // 逆时针旋转
              color: ['#98c731','#ea5413'],
              itemStyle:{
                show: true,
                shadowColor: ['rgba(255, 255, 255, 0.41)'],
                shadowBlur: [shadowBlur],
              },
              labelLine: {
                length: (20/100)*htmlFontSize,
                length2: (75/100)*htmlFontSize,
                lineStyle: {
                  color: '#ffffff'
                }
              },
              // avoidLabelOverlap: false,
              label: {
                normal: {
                  formatter: '{a|{c}}\n{b|{b}}',
                  borderWidth: 0,
                  borderRadius: (4/100)*htmlFontSize,
                  padding: [0, -labelFPadding],
                  rich: {
                    a: {
                      color: '#ffffff',
                      align:'center',
                      fontSize: aFontSize,
                      padding: aPadding,
                      fontWeight: 'normal',
                    },
                    b: {
                      align:'center',
                      fontSize: bFontSize,
                      padding: bPadding,
                      color: '#ffffff'
                    },
                  }
                },
              },
              data:[
                {value: OnlineNum, name:'在线设备数'},
                {value: OfflineNum, name:'离线设备数'}
              ]
            }
          ]
        }
        myChart.setOption(option)
      },
      // 屏幕变化图表自适应加载
      resizeGetChart () {
        echarts.init(document.getElementById('onlineRateGM')).resize()
      },
      // 获取固定（通用）版块的设备信息
      async getGMDeviceInfo () {
        let res = await dkbApi.getGMDeviceInfo()
        if (res.ErrCode === 0) {
          vm.DeviceArea = res.Result
          vm.$nextTick(()=>{
            vm.getDeviceDC()
          })
        } else {
          showToast(res.ErrMsg)
        }
      },
      // 获取固定（通用）版块的实时操作记录
	    async getGMRealOperateInfo (){
        let res = await dkbApi.getGMRealOperateInfo()
        if (res.ErrCode === 0) {
          vm.RealOperateArea = res.Result
        } else {
          showToast(res.ErrMsg)
        }
      },
      // 获取固定（通用）版块的实时操作记录
	    async getGMKCSLInfo (){
        let res = await dkbApi.getGMKCSLInfo()
        if (res.ErrCode === 0) {
          vm.KCSLArea = res.Result
        } else {
          showToast(res.ErrMsg)
        }
      },
      // 获取固定（通用）版块的预警信息
      async getGMWarningInfo () {
        let res = await dkbApi.getGMWarningInfo()
        if (res.ErrCode === 0) {
          // vm.WarningText = res.Result.WarningText
          vm.WarningInfo = res.Result
        } else {
          showToast(res.ErrMsg)
        }
      },
    },
    watch: {
      // 屏幕变化，图表自适应加载
      '$store.state.isOnresize' (newVal, oldVal) {
        // console.log('屏幕变化', newVal)
        if (newVal !== oldVal) {
          vm.resizeGetChart()
        }
      },
    }
  }
</script>

<style lang="scss" scoped>
.DkbGM {
  margin-left: 0.25rem;
  flex-shrink: 0;
  width: 5.98rem;
  height: 100%;
  padding: 0.3rem 0.06rem 0.3rem 0.45rem;
  box-shadow:rgba(0, 0, 0, 0.2) 0 0 0.34rem;
  background: url('/static/images/dkb/GM_bg.png') center no-repeat;
  background-size: 5.98rem 100%;
  .GMContent {
    width: 100%;
    height: 100%;
    padding-right: 0.27rem;
    overflow-x: hidden;
    overflow-y: scroll;
    // 设备
    .deviceArea {
      width: 100%;
      display: flex;
      justify-content: space-between;
      .chart {
        flex-shrink: 0;
        width: 3rem;
        height: 2.5rem;
        position: relative;
        display: flex;
        flex-direction: column;;
        align-items: center;
        justify-content: center;
        #onlineRateGM {
          width: inherit;
          height: inherit;
          position: absolute;
          left: 0;
          top: 0;
        }
        .text {
          font-size: 0.15rem;
        }
        .num {
          font-size: 0.4rem;
          font-weight: lighter;
        }
      }
      .right {
        width: 100%;
        height: 2.1rem;
        padding-top: 0.05rem;
        display: flex;
        justify-content: space-between;
        position: relative;
        .tit {
          flex-shrink: 0;
          margin-bottom: 0.07rem;
          font-size: 0.15rem;
          text-align: center;
        }
        .listBox {
          flex-shrink: 0;
          width: 0.78rem;
          height: 100%;
          display: flex;
          flex-direction: column;
          .list {
            height: 100%;
            overflow-x: hidden;
            overflow-y: scroll;
            .li {
              width: 0.63rem;
              height: 0.2rem;
              line-height: 0.2rem;
              font-size: 0.12rem;
              text-indent: 0.08rem;
              background-color: #072c4e;
            }
            .li:nth-child(even){
              background-color: #103c5c;
            }
            .li.selected {
              box-sizing: border-box;
              border:0.01rem solid #7ca2c6;
              box-shadow: 0 0 0.03rem rgba(122,160,195,0.41);
              -webkit-box-shadow: 0 0 0.03rem rgba(122,160,195,0.41);
            }
          }
          
        }
        .detailBox {
          // width: 1.26rem;
          width: 100%;
          margin-left: 0.02rem;
          height: 100%;
          display: flex;
          flex-direction: column;
          .detail {
            padding: 0.07rem 0.1rem 0 0.14rem;
            height: 100%;
            background-color: #072c4e;
            font-size: 0.12rem;
            line-height: 0.22rem;
          }
        }
        .noDevice{
          width: 100%;
          text-align: center;
          font-size: 0.16rem;
          color: #cccccc;
          position: absolute;
          top: 0.8rem;
        }
      }
    }
    // 实时操作
    .realOperateArea {
      width: 100%;
      .Tit {
        margin: 0.1rem 0;
        font-size: 0.15rem;
        text-align: center;
      }
      .li.tit {
        width: 100%;
        height: 0.33rem;
        line-height: 0.33rem;
        margin-bottom: 0.03rem;
        .con {
          text-align: center;
        }
      }
      .li {
        width: 4.89rem;
        font-size: 0.12rem;
        line-height: 0.22rem;
        background-color: #072c4e;
        display: flex;
        .time {
          flex-shrink: 0;
          width: 1.39rem;
          text-align: center;
        }
        .con {
          width: 100%;
        }
      }
      .list {
        width: 100%;
        max-height: 1.62rem;
        overflow-x: hidden;
        overflow-y: scroll;
        .li:first-child{
          padding-top: 0.06rem;
        }
        .li:last-child{
          padding-bottom: 0.06rem;
        }
      }
    }
    // 库存记录
    .KCSLArea {
      width: 100%;
      .Tit {
        margin: 0.14rem 0 0.1rem;
        font-size: 0.15rem;
        text-align: center;
      }
      .li.tit {
        width: 100%;
        height: 0.34rem;
        line-height: 0.34rem;
      }
      .li {
        width: 4.9rem;
        padding-left: 0.2rem;
        font-size: 0.12rem;
        line-height: 0.24rem;
        text-align: center;
        background-color: #072c4e;
        display: flex;
        .warehouse {
          flex-shrink: 0;
          width: 1.1rem;
        }
        .name {
          flex-shrink: 0;
          width: 1.5rem;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 1;
          overflow: hidden;
        }
        .number {
          flex-shrink: 0;
          width: 1.3rem;
        }
        .status {
          flex-shrink: 0;
          // width: 1.15rem;
          width: 0.8rem;
        }
      }
      .list {
        width: 100%;
        max-height: 1.62rem;
        overflow-x: hidden;
        overflow-y: scroll;
        .li:nth-child(odd) {
          background-color: #103b5c;
        }
      }
    }
    // 预警信息
    .warningArea {
      width: 100%;
      height: 1.06rem;
      margin-top: 0.16rem;
      padding-right: 0.03rem;
      background: url('/static/images/dkb/warning_bg.png') center no-repeat;
      background-size: 5.06rem 100%;
      position: relative;// 有预警信息
      display: flex;
      flex-direction: column;
      &.has {
        transition: 1s;
        background: url('/static/images/dkb/warning_bg_ing.png') center no-repeat;
        background-size: 5.06rem 100%;
        .tit {
          color: #ea5413;
        }
        .text {
          padding-top: 0.18rem;
        }
      }
      .tit {
        font-size: 0.15rem;
        color: #7ca9d0;
        letter-spacing: 0.02rem;
        text-shadow: 0 0 0.01rem rgba(255, 255, 255, 0.29);
        position: absolute;
        left: 0;
        top: -0.05rem;
      }
      .text {
        padding: 0.22rem 0.2rem 0;
        font-size: 0.12rem;
        line-height: 0.20rem;
      }
      .list {
        margin-top: 0.19rem;
        margin-bottom: 0.1rem;
        width: 100%;
        height: 100%;
        overflow-x: hidden;
        overflow-y: auto;
        .li {
          width: 100%;
          padding-left: 0.12rem;
          padding-top: 0.1rem;
          font-size: 0.12rem;
          line-height: 1;
          .top {
            width: 100%;
            margin-bottom: 0.05rem;
            color: #ffffff;
            display: flex;
            .time {
              margin-right: 0.23rem;
            }
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/DkbPage/GM/GM.vue